<div class="flex justify-end items-end">
    <div class="flex-col">
        <p class="ml-2 mb-0 mt-0">Powered by</p>
        <img (click)="onLogoClick()" src=",./../assets/images/logo-es-azul.png" width="125" height="30"
            class="cursor-pointer">
        <p class="ml-2 mb-0 mt-0">&copy; {{currentYear}} - v2.0.1</p>
    </div>
</div>
